/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { ErrorHandler, Injectable } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { take, tap } from "rxjs";
import { DialogComponent } from "../components/dialog/dialog.component";
import { DialogCloseReason } from "../models/ui/dialog-close-reason.model";
import { DialogService } from "../services/dialog.service";
import { logError, shouldOpenErrorDialog } from "../utils/utils";

@Injectable({
	providedIn: "root"
})
export class GlobalictccErrorHandler implements ErrorHandler {
	private _dialogRef: MatDialogRef<DialogComponent, DialogCloseReason> | null = null;

	constructor(private _dialogService: DialogService) {}

	/**
	 * Handles errors by logging them to the console and displaying an error dialog to the user.
	 *
	 * @param error - The error object that was thrown.
	 */
	public handleError(error: unknown) {
		logError(error);

		if (shouldOpenErrorDialog(error, this._dialogRef)) {
			this._dialogRef = this._dialogService.open({
				data: {
					type: "info",
					title: "Something went wrong",
					message:
						"An error occurred while processing your request. Please try again later.",
					iconName: "warning-hex",
					isIconVisible: true,
					closeBtnText: "Ok"
				}
			});

			this._dialogRef
				.afterClosed()
				.pipe(take(1), tap({ next: () => (this._dialogRef = null) }))
				.subscribe();
		}
	}
}
